import { useMutation, useQuery } from '@tanstack/react-query';

import { GradeSheetsQueryKeys, useGradeSheetsApi } from '@/api';
import { mapGradeSheets } from '@/api/api-mappers';
import { GetGradeSheetsRequest } from '@/api/api-queries/duck';

export const useGetGradeSheets = (request: GetGradeSheetsRequest) => {
  const { gradeSheetsApi } = useGradeSheetsApi();

  const { data, isLoading } = useQuery({
    queryKey: [GradeSheetsQueryKeys.gradeSheetsList, request],
    queryFn: async () => {
      const response = await gradeSheetsApi.getGradesheetsApiGradesheetsGet(
        request?.gradesheetId,
        request?.assessmentId,
        request?.grader,
        null,
      );
      return mapGradeSheets(response.data);
    },
    enabled: !!request.gradesheetId || !!request.assessmentId || !!request.grader
  });

  return {
    gradeSheets: data,
    isGradeSheetsLoading: isLoading
  }
}

export const useDeleteGradeSheet = () => {
  // const queryClient = useQueryClient();
  const { gradeSheetsApi } = useGradeSheetsApi();

  const { mutateAsync, isPending, isError, error } = useMutation({
    mutationFn: (id: string) => gradeSheetsApi.deleteGradesheetApiGradesheetsGradesheetIdDelete(id),
    /*onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [GradeSheetsQueryKeys.gradeSheetsList],
      });
    },*/
  });

  return {
    deleteGradeSheet: mutateAsync,
    isGradeSheetDeleting: isPending,
    isGradeSheetError: isError,
    gradeSheetError: error,
  };
}